// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Cak1A","title":"styles_title__ra9mh","info":"styles_info__shSAF","network":"styles_network__DcMWx"};